export default import.meta.ROLLDOWN_FILE_URL_u8egkvGY7JAETGkFYZzsbg